// Node
const $ = require('jquery');
require('jquery.cookie');

import {openPopupById} from "../desktop/common/popup";

const leadCatcher = function () {
  const viewedPages = getViewedPages();
  const currentPage = window.location.pathname;

  if (!viewedPages.has(currentPage)) {
    viewedPages.add(currentPage);
    $.cookie('viewed_pages', JSON.stringify([...viewedPages]), { path: '/' });
  }

  if (viewedPages.size >= 2 && !containsAccountPage(viewedPages)) {
    document.addEventListener('mouseleave', handleMouseLeave);
  }
}

function getViewedPages() {
  const viewedPages = $.cookie('viewed_pages');
  return viewedPages ? new Set(JSON.parse(viewedPages)) : new Set();
}

function handleMouseLeave(e) {
  if (e.clientY <= 0) {
    showLeadCatcher();
  }
}

function showLeadCatcher() {
  const leadCatcherShown = $.cookie('lead_catcher_show');
  if (!leadCatcherShown) {
    $.get('/check_lead_catcher', function (data) {
      if (data.show_lead_catcher) {
        $('#auth-login-form').hide();
        $('#auth-register-form').show();
        $('#auth-popup a.popup-tabs__tab-active').removeClass('popup-tabs__tab-active');
        $('a[data-target="auth-register-form"]').addClass('popup-tabs__tab-active');
        openPopupById('auth-popup');
      }
      $.cookie('lead_catcher_show', "true", { path: '/' });
    });
  }
}

/**
 * @param {Set} pages
 * @returns {boolean}
 */
function containsAccountPage(pages) {
  return [...pages].some((page) => page.includes('account'));
}

export { leadCatcher }
